export default [
    {
        path: '/master/departments',
        name: 'departments',
        props: true,
        component: () => import('@/views/master/departments/index.vue'),
        meta: {
            pageTitle: 'Departments',
            breadcrumb: [
                {
                text: 'Departments',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/departments/add',
        name: 'create-departments',
        component: () => import('@/views/master/departments/create.vue'),
        meta: {
            pageTitle: 'Create Department',
            breadcrumb: [
                {
                text: 'Departments',
                to: { name: 'departments' },
                },
                {
                text: 'Create Department',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/departments/:id',
        name: 'detail-departments',
        props: true,
        component: () => import('@/views/master/departments/detail.vue'),
        meta: {
            pageTitle: 'Detail Department',
            breadcrumb: [
                {
                text: 'Departments',
                to: { name: 'departments' },
                },
                {
                text: 'Detail Department',
                active: true,
                },
            ],
        },
    },
]